import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Box, Button, Grid, IconButton } from "@mui/material";
import { SaveRounded } from "@mui/icons-material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import DataTable from "../../components/common/DataTable";
import CustomTextField from "../common/CustomTextField";
import CustomButton from "../common/CustomButton";
import { getCallOutcomeType } from "../../services/CommonServices";

const title = "Call Outcome Types";

const CallOutcomeTypes = () => {
    const navigate = useNavigate();
    const [callOutcomeTypes, setCallOutcomeTypes] = useState([]);

    const [formData, setFormData] = useState({
        shortName: "",
        callOutcomeType: "",
    });

    const columns = useMemo(
        () => [
            { accessorKey: 'id', header: 'SN', size: 50 },
            { accessorKey: 'shortName', header: 'Short Name', size: 150 },
            { accessorKey: 'title', header: 'Call Outcome Type', size: 200 },
            {
                accessorKey: "action",
                header: "Action",
                size: 50,
                Cell: ({ row }) => (
                    <IconButton onClick={() => handleViewClick(row.original.sn)}>
                        <VisibilityIcon />
                    </IconButton>
                ),
            },
        ],
        []
    );

    const handleViewClick = (id) => {
        navigate(`/app/call-outcome/${id}`);
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const getCallOutcomeData = async () => {
        const callOutcomeTypesData = await getCallOutcomeType();
        setCallOutcomeTypes(callOutcomeTypesData);
    };

    useEffect(() => {
        getCallOutcomeData();
    }, []);

    return (
        <>
            <Box sx={{ paddingLeft: "10px" }} >
                <form>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                            <CustomTextField
                                type="text"
                                name="shortName"
                                fieldLabel="Short Name:"
                                value={formData.shortName}
                                required={true}
                                onChange={handleChange}
                                placeholder="Enter Short Name"
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                            <CustomTextField
                                type="text"
                                name="callOutcomeType"
                                fieldLabel="Call Outcome Type:"
                                value={formData.callOutcomeType}
                                required={true}
                                onChange={handleChange}
                                placeholder="Enter Call Outcome Type"
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                            <br />
                            <CustomButton
                                startIcon={<SaveRounded />}
                                title="Save"
                                size="small"
                                variant="contained"
                            />
                        </Grid>
                    </Grid>
                </form>
            </Box>
            <Box sx={{ padding: "10px" }}>
                <DataTable
                    title={title}
                    columns={columns}
                    data={callOutcomeTypes}
                />
            </Box>
        </>
    );
};

export default CallOutcomeTypes;
